import React from 'react';
import { Text } from '@atlaskit/primitives';
import { RendererContext } from '../../../context';
import warnOnce from '../../../utils/warn-once';
var useDeprecationWarning = function useDeprecationWarning(componentName) {
  var _React$useContext = React.useContext(RendererContext),
    forgeEnvironment = _React$useContext.forgeEnvironment;
  React.useEffect(function () {
    if (forgeEnvironment !== 'PRODUCTION') {
      warnOnce("[@forge/react: ".concat(componentName, "] Warning: The \"").concat(componentName, "\" component is deprecated and will be removed on the 28th of August 2025. Please use the \"Text\" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/."));
    }
  }, [forgeEnvironment, componentName]);
};
var AkButton = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.button/custom-theme-button' */
  '@atlaskit/button/custom-theme-button');
});

// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
var PROTOCOL_ALLOWLIST = ['http:', 'https:', 'ftp:', 'ftps:', 'mailto:', 'skype:', 'callto:', 'facetime:', 'git:', 'irc:', 'irc6:', 'news:', 'nntp:', 'feed:', 'cvs:', 'svn:', 'mvn:', 'ssh:', 'scp:', 'sftp:', 'itms:', 'notes:', 'hipchat:', 'sourcetree:', 'urn:', 'tel:', 'xmpp:', 'telnet:', 'vnc:', 'rdp:', 'whatsapp:', 'slack:', 'sip:', 'sips:', 'magnet:', 'tds:'];
export var sanitizeUrl = function sanitizeUrl(urlString) {
  var url = new URL(urlString || '', window.location.href);
  if (PROTOCOL_ALLOWLIST.includes(url.protocol)) {
    return url.toString();
  } else {
    return 'about:blank';
  }
};

// this is different to Rendered<T>, as ReactNode supports inline strings

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated The "Em" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.
 */
export function Em(_ref) {
  var children = _ref.children;
  useDeprecationWarning('Em');
  return /*#__PURE__*/React.createElement(Text, {
    as: "em"
  }, children);
}
export function Link(_ref2) {
  var href = _ref2.href,
    children = _ref2.children,
    openNewTab = _ref2.openNewTab,
    appearance = _ref2.appearance;
  var sanitizedHref = sanitizeUrl(href);
  if (appearance === 'primary-button' || appearance === 'button') {
    return /*#__PURE__*/React.createElement(AkButton, {
      appearance: appearance === 'primary-button' ? 'primary' : 'default',
      href: sanitizedHref,
      rel: "noopener noreferrer",
      target: openNewTab ? '_blank' : undefined
    }, children);
  } else {
    return /*#__PURE__*/React.createElement("a", {
      href: sanitizedHref,
      rel: "noopener noreferrer",
      target: openNewTab ? '_blank' : undefined
    }, children);
  }
}

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated The "Strike" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.
 */
export function Strike(_ref3) {
  var children = _ref3.children;
  useDeprecationWarning('Strike');
  return /*#__PURE__*/React.createElement("s", null, children);
}
export function String(_ref4) {
  var text = _ref4.text;
  useDeprecationWarning('String');
  return /*#__PURE__*/React.createElement(React.Fragment, null, text);
}

// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * @deprecated The "Strong" component is deprecated and will be removed on the 28th of August 2025. Please use the "Text" component instead. For more information, visit: https://developer.atlassian.com/platform/forge/ui-kit/components/text/.
 */
export function Strong(_ref5) {
  var children = _ref5.children;
  useDeprecationWarning('Strong');
  return /*#__PURE__*/React.createElement(Text, {
    as: "strong"
  }, children);
}
function wrap(Component) {
  return function WrappedComponent(_ref6) {
    var Components = _ref6.Components,
      children = _ref6.children,
      propsAny = _ref6.props,
      render = _ref6.render,
      renderChildren = _ref6.renderChildren,
      dispatch = _ref6.dispatch;
    var props = propsAny;
    return /*#__PURE__*/React.createElement(Component, props, renderChildren({
      Components: Components,
      children: children,
      render: render,
      dispatch: dispatch
    }));
  };
}
export var EmFn = wrap(Em);
export var LinkFn = wrap(Link);
export var StrikeFn = wrap(Strike);
export var StringFn = wrap(String);
export var StrongFn = wrap(Strong);